<template>
  <div class="step-placeholder text-center py-16 text-medium-emphasis">
    <v-icon size="48" class="mb-2">mdi-cog-outline</v-icon>
    <div class="text-body-1">「{{ title }}」</div>
    <div class="text-body-2">{{ description }}</div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  description: {
    type: String,
    default: '该步骤可在后续迭代中接入运行策略与电价等配置。',
  },
})
</script>

<style scoped>
.step-placeholder {
  min-height: 240px;
}
</style>
